import styled, { css } from 'styled-components';
import { devices } from '../../../../juristec-ui/core/breakpoints';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  user-select: none;
  margin: 0 5px;
  max-width: 300px;
  @media ${devices.phoneS} {
    max-width: auto;
  }
`;

export const PresetContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 5px;
  width: 100%;
  & button {
    width: 100%;
    padding: 1px 2px 2px 2px;
    min-width: auto;
    white-space: break-spaces;
    font-size: 12px;
  }
`;

export const OptionGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  align-items: center;
  justify-content: center;
`;

interface OptionProps {
  active?: boolean;
  theme: Record<string, string>;
}

export const Option = styled.button<OptionProps>`
  background-color: ${({ theme }) => theme.containerOdd};
  color: ${({ theme }) => theme.primary};
  padding: 5px;
  border: none;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: auto;
  font-weight: bold;
  height: 38px;
  cursor: pointer;
  & svg {
    height: 22px;
    width: 22px;
    margin-right: 5px;
  }
  ${({ theme, active }) => (active ? css`
    background-color: ${theme.primary};
    color: ${theme.white};
    & svg {
      fill: ${theme.white};
    }
  ` : css`
    &:hover {
      background-color: ${theme.selectHover};
    }
  `)}
`;
